import * as Yup from "yup";
import CAFragment from "./CAFragment";

const schema = Yup.object({
  workCountry: Yup.string().oneOf(["CA"]).required("Required"),
  requireClientBusinessDescription: Yup.boolean().default(false).strip(true),
  clientBusinessDescription: Yup.string().when(
    "requireClientBusinessDescription",
    {
      is: true,
      then: (schema) => schema.required("Required"),
      otherwise: (schema) => schema.notRequired().strip(true),
    }
  ),
  probationPeriodDays: Yup.string()
    .required("Required")
    .oneOf(["0", "90"], "Must be none or 90 days."),
  caPtoAllowanceType: Yup.string()
    .oneOf(["statutory", "unlimited", "custom"], "Invalid selection")
    .required("Required"),
  caPtoAllowanceDays: Yup.number()
    .nullable()
    .when("caPtoAllowanceType", (caPtoAllowanceType, schema) => {
      return String(caPtoAllowanceType) === "custom"
        ? schema
            .nonNullable()
            .required("Required")
            .min(10, "Must be 10 or greater.")
        : schema;
    }),
});

export type ConfigType = {
  component: JSX.Element;
  schema: typeof schema;
  initialValues: SchemaType;
  keysToExclude?: Partial<keyof SchemaType>[];
};

export type SchemaType = Omit<
  Yup.InferType<typeof schema>,
  "requireClientBusinessDescription"
> & {
  requireClientBusinessDescription?: boolean | null;
};

const CONFIG: ConfigType = {
  component: <CAFragment />,
  schema: schema,
  initialValues: {
    workCountry: "CA",
    requireClientBusinessDescription: false,
    clientBusinessDescription: "",
    caPtoAllowanceType: "statutory",
    caPtoAllowanceDays: null,
    probationPeriodDays: "0",
  },
  keysToExclude: ["requireClientBusinessDescription"],
};

export default CONFIG;
